import { render, staticRenderFns } from "./UpdateOrders.vue?vue&type=template&id=bca457a8&"
import script from "./UpdateOrders.vue?vue&type=script&lang=js&"
export * from "./UpdateOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports